module.exports = __webpack_public_path__ + "static/c21e78f7f06fa1f2df3ec7cf787b9d152b822942276b39890f85b865187becce-d92fd143ffb45b73829284f97f105133.png";